import styled from 'styled-components';
import { Button, Select } from '@hiiretail/synergy-ui';

export const CancelButton = styled(Button)`
  margin-right: 16px;
`;

export const BusinessUnitSelect = styled(Select)`
  height: 460px;
`;
